/*
**************************** 
홈페이지 공지 내용
*****************************
*/

import moment from "moment";
import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import "../css/BoardContent.scss";

export default function BoardContent(props) {
    const pathData = useParams();

    let idx = props.idx;
    let page = props.page;
    const [content, setContent] = useState(null);
    const navigate = useNavigate();
    const idxRef = useRef();

    useEffect(() => {
        if (props.data.length > 0) {
            idxRef.current = pathData.idx;
            const data = props.data;
            setContent(getCell(props.idx));
        }
    }, [props]);

    const getCell = function (idx) {
        const data = props.data;

        let cell;
        for (let i = 0; i < data.length; i++) {
            const obj = data[i];

            if (obj.id == idx) {
                cell = obj;
                break;
            }
        }
        return cell;
    }

    const getFindCell = function (idx) {
        const data = props.data;

        let cell;
        for (let i = 0; i < data.length; i++) {
            const obj = data[i];

            if (obj.ROWNUM == idx) {
                cell = obj;
                break;
            }
        }
        return cell;
    }

    return (
        <div className="container">
            <div className="content-base">
                <div className="content-title fs-6 mt-2">
                    {content !== null ? content.title : null}
                </div>
                <div className="content-date text-start mt-2">
                    {content !== null ? <span>{moment(content.created_at).format('YYYY-MM-DD HH:mm')} </span> : null}
                </div>
                <div className="content-msg">
                    {content !== null ? <div dangerouslySetInnerHTML={{ __html: content.content_msg }}></div> : ""}
                </div>
                <div className="pvl-bar row">
                </div>
            </div>
        </div>
    )
}